<template>
  <div class="height-100 d-flex">
    <div class="authCard m-auto">
      <img src="@/assets/smart-stewards.png" class="header-logo" height="85" width="85" alt="Logo">
      <h3>Forgot Password?</h3>
      <p class="secondary-text">Enter email address to reset it</p>
      <form class="auth-form" @submit="forgot">
        <div class="form-group">
          <input type="text" v-model="email" placeholder="Email Address" class="form-control"
          required>
          <p v-if="error" class="error-msg">Email address does not exist</p>
        </div>

        <div>
          <button class="btn primary-btn btn-block" :disabled="isDisabled">
            <span v-if="!loading"> Send Email </span>
            <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
            </vue-loaders-ball-spin-fade-loader>
          </button>
        </div>
      </form>
       <p class="open-sans"><span class="secondary-text">Remember?</span>
        <router-link to="/signin"> Sign In </router-link></p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDisabled() {
      if (!this.email) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      email: '',
      loading: false,
      error: false,
    };
  },
  methods: {
    async forgot(e) {
      e.preventDefault();
      this.loading = true;
      const data = { email: this.email };
      const url = `${this.$baseUrl}/password/forgot`;
      const res = await this.$http({ url, data, method: 'POST' });
      this.$toast.open(res.data.message, {
        duration: 2500,
        type: 'success',
        dismissible: true,
      });
      this.loading = false;
    },
  },
};
</script>

<style scoped>
  .d-flex{
    background-color: #FFF;
  }
  a {
    color: #EE0E4C;
  }
</style>
